// ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();



  if (!isAuthenticated) {
    return <Navigate to="/login" />; // Redireciona para login caso não esteja autenticado
  }

  return <>{children}</>;
};

export default ProtectedRoute;
